/**
 * 错误处理工具函数
 */

/**
 * 检查是否为使用限制错误
 * @param {Object} errorResponse 错误响应对象
 * @returns {boolean} 是否为使用限制错误
 */
export function isUsageLimitError(errorResponse) {
  if (!errorResponse) return false;
  
  // 检查错误消息是否包含使用限制信息
  if (errorResponse.message && errorResponse.message.includes('超出月度使用限制')) {
    return true;
  }
  
  // 检查data.permissionCheck结构
  if (errorResponse.data && errorResponse.data.permissionCheck) {
    const permissionCheck = errorResponse.data.permissionCheck;
    return permissionCheck && !permissionCheck.allowed && !!permissionCheck.reason;
  }
  
  return false;
}

/**
 * 获取使用限制错误信息
 * @param {Object} errorResponse 错误响应对象
 * @returns {Object} 使用限制信息
 */
export function getUsageLimitInfo(errorResponse) {
  // 优先从permissionCheck获取详细信息
  if (errorResponse.data && errorResponse.data.permissionCheck) {
    const permissionCheck = errorResponse.data.permissionCheck;
    return {
      reason: permissionCheck.reason,
      subscriptionType: permissionCheck.subscriptionType,
      currentUsage: permissionCheck.currentUsage,
      maxAllowed: permissionCheck.maxAllowed,
      planName: permissionCheck.planName
    };
  }
  
  // 如果没有permissionCheck，从message中解析信息
  if (errorResponse.message) {
    return {
      reason: errorResponse.message,
      subscriptionType: 'FREE',
      currentUsage: 0,
      maxAllowed: 0,
      planName: null
    };
  }
  
  return {
    reason: '超出使用限制',
    subscriptionType: 'FREE',
    currentUsage: 0,
    maxAllowed: 0,
    planName: null
  };
}

/**
 * 格式化使用限制消息
 * @param {Object} limitInfo 使用限制信息
 * @param {Function} $t 翻译函数
 * @param {Object} currentLang 当前语言对象（可选）
 * @returns {string} 格式化后的消息
 */
export function formatUsageLimitMessage(limitInfo, $t, currentLang = null) {
  if (!limitInfo) return '';
  
  // 从原因中提取数字信息
  let requestCount = '0';
  if (limitInfo.reason) {
    // 支持中文和英文的正则匹配
    const chineseRequestMatch = limitInfo.reason.match(/本次请求[：:]\s*(\d+)/);
    const englishRequestMatch = limitInfo.reason.match(/this request[：:]\s*(\d+)/i);
    
    if (chineseRequestMatch && chineseRequestMatch[1]) {
      requestCount = chineseRequestMatch[1];
    } else if (englishRequestMatch && englishRequestMatch[1]) {
      requestCount = englishRequestMatch[1];
    }
  }
  
  // 判断当前语言环境
  let isChinese = false;
  
  if (currentLang) {
    // 如果传递了语言对象，直接判断
    isChinese = currentLang.locale === 'zh-cn';
  } else {
    // 否则尝试通过翻译函数安全地判断
    try {
      const testTranslation = $t('Current usage');
      isChinese = testTranslation === '当前使用';
    } catch (error) {
      // 如果翻译函数有问题，回退到基于原因的判断
      isChinese = limitInfo.reason && limitInfo.reason.includes('超出月度使用限制');
    }
  }
  
  if (isChinese) {
    // 中文环境
    return `超出月度使用限制，当前已使用: ${limitInfo.currentUsage}/${limitInfo.maxAllowed}, 本次请求: ${requestCount}`;
  } else {
    // 英文环境
    return `Monthly usage limit exceeded. Current usage: ${limitInfo.currentUsage}/${limitInfo.maxAllowed}, This request: ${requestCount}`;
  }
}

/**
 * 跳转到价格页面
 * @param {Object} router Vue Router实例
 * @param {string} message 错误消息
 */
export function redirectToPricing(router, message) {
  router.push({
    path: '/pricing',
    query: {
      fromLimit: 'true',
      message: message
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils/errorHandler.js